import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useTestimonials } from "../hooks/useTestimonials";

const HomeProblemSection: React.FC = () => {
  const { t } = useTranslation();
  const { avgScore, testimonials, loading } = useTestimonials();
  const s = t("problemSection", { returnObjects: true }) as {
    quote: string;
    body: string;
    stats: { value: string; label: string }[];
  };

  const liveRating = !loading && testimonials.length > 0
    ? `${avgScore.toFixed(1)} / 10`
    : null;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-2xl md:text-3xl font-bold text-main mb-4"
        >
          {s.quote}
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-lg text-gray-500 whitespace-pre-line mb-16"
        >
          {s.body}
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {s.stats.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="text-center"
            >
              <p className="text-2xl md:text-3xl font-extrabold text-main mb-1">
                {i === 1 && liveRating ? liveRating : stat.value}
              </p>
              <p className="text-sm text-gray-400">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeProblemSection;
